import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const Loading = () => {
  return (
    <Box
      sx={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "50px"}}
    >
      <CircularProgress color="success"/>
    </Box>
  );
};

export default Loading;
